(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2c90"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2c90"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = new Map();
function $0380ce8f1f064ccc$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0380ce8f1f064ccc$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

parcelRegister("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

var $f44265643127a020$exports = {};


(parcelRequire("iE7OH")).register((parcelRequire("aNJCr")).getBundleURL("4a7ff"), JSON.parse('["4a7ff","index.d12e3816.js","hDqTj","applause-1.6fb96cce.gif","8GDtZ","memorytile-beep.80d5ed15.mp3","3S3uA","applause-sound.db1c2c2e.mp3","9phPv","applause-2.1cb0fbb3.gif","g4Bw2","applause-3.4ebe40a3.gif","7pRsM","applause-4.3e0e6d2f.gif"]'));

var $92613537cea89aa2$exports = {};

$92613537cea89aa2$exports = (parcelRequire("aNJCr")).getBundleURL("4a7ff") + "applause-1.6fb96cce.gif";


var $b49ded1f4ce6225d$exports = {};

$b49ded1f4ce6225d$exports = (parcelRequire("aNJCr")).getBundleURL("4a7ff") + "applause-2.1cb0fbb3.gif";


var $beb728e107eda2af$exports = {};

$beb728e107eda2af$exports = (parcelRequire("aNJCr")).getBundleURL("4a7ff") + "applause-3.4ebe40a3.gif";


var $44da6374d029a4b3$exports = {};

$44da6374d029a4b3$exports = (parcelRequire("aNJCr")).getBundleURL("4a7ff") + "applause-4.3e0e6d2f.gif";


"use strict";
var $0d4355b81aa4f14c$exports = {};

$0d4355b81aa4f14c$exports = (parcelRequire("aNJCr")).getBundleURL("4a7ff") + "memorytile-beep.80d5ed15.mp3";


/* imports sounds*/ const $4a1d03bd5b66f9fc$var$tileBeep = new URL($0d4355b81aa4f14c$exports);
var $78f95ab19dc49834$exports = {};

$78f95ab19dc49834$exports = (parcelRequire("aNJCr")).getBundleURL("4a7ff") + "applause-sound.db1c2c2e.mp3";


const $4a1d03bd5b66f9fc$var$applause = new URL($78f95ab19dc49834$exports);
/* sound effects */ const $4a1d03bd5b66f9fc$var$memoryTileBeep = new Audio($4a1d03bd5b66f9fc$var$tileBeep);
$4a1d03bd5b66f9fc$var$memoryTileBeep.volume = 0.2;
const $4a1d03bd5b66f9fc$var$applauseSound = new Audio($4a1d03bd5b66f9fc$var$applause);
$4a1d03bd5b66f9fc$var$applauseSound.volume = 0.5;
/* DOM variables */ /* ------------------------------------------------- */ const $4a1d03bd5b66f9fc$var$startGame = document.querySelector(".start-game");
const $4a1d03bd5b66f9fc$var$quitBtn = document.querySelector(".btn-quit");
const $4a1d03bd5b66f9fc$var$previousBtn = document.querySelector(".btn-previous");
const $4a1d03bd5b66f9fc$var$memoryBlockArea = document.querySelector(".memory-block-area");
const $4a1d03bd5b66f9fc$var$memoryBlock = document.getElementsByClassName("memory-block");
const $4a1d03bd5b66f9fc$var$highScoreEL = document.querySelector(".high-score-number");
const $4a1d03bd5b66f9fc$var$currentScoreEL = document.querySelector(".current-score-number");
const $4a1d03bd5b66f9fc$var$messageBox = document.querySelector(".message-text");
const $4a1d03bd5b66f9fc$var$highScoreMessage = document.querySelector(".high-score-text");
const $4a1d03bd5b66f9fc$var$highScoreModal = document.getElementById("high-score-modal");
const $4a1d03bd5b66f9fc$var$highScoreNumberModal = document.querySelector(".high-score-number-modal");
const $4a1d03bd5b66f9fc$var$highScoreModalGif = document.querySelector(".high-score-applause-gif");
const $4a1d03bd5b66f9fc$var$gridCol = document.getElementsByClassName("grid-col");
const $4a1d03bd5b66f9fc$var$easyDifficulty = document.getElementById("easy");
const $4a1d03bd5b66f9fc$var$mediumDifficulty = document.getElementById("medium");
const $4a1d03bd5b66f9fc$var$hardDifficulty = document.getElementById("hard");
const $4a1d03bd5b66f9fc$var$customDifficulty = document.getElementById("custom");
const $4a1d03bd5b66f9fc$var$difficultySelectMenu = document.getElementById("difficulty-select-menu");
const $4a1d03bd5b66f9fc$var$customDifficultyMenu = document.getElementById("custom-difficulty");
const $4a1d03bd5b66f9fc$var$gameArea = document.getElementById("game-area");
const $4a1d03bd5b66f9fc$var$amountCustomDifficulty = document.getElementById("amount-custom-difficulty");
const $4a1d03bd5b66f9fc$var$nextCustomDifficulty = document.querySelector(".custom-difficulty-next");
const $4a1d03bd5b66f9fc$var$messageBoxCustom = document.querySelector(".message-custom-tiles");
let $4a1d03bd5b66f9fc$var$screenWidth = screen.width;
let $4a1d03bd5b66f9fc$var$numberOfTiles = 6;
let $4a1d03bd5b66f9fc$var$generatedNumbersSequence = [];
let $4a1d03bd5b66f9fc$var$playerNumbersSequence = [];
let $4a1d03bd5b66f9fc$var$memoryTiles = [];
let $4a1d03bd5b66f9fc$var$currentScore = 0;
let $4a1d03bd5b66f9fc$var$highScore = 0;
let $4a1d03bd5b66f9fc$var$playerTurn = false;
let $4a1d03bd5b66f9fc$var$computerTurn = false;
let $4a1d03bd5b66f9fc$var$newHighScore = false;
let $4a1d03bd5b66f9fc$var$gameAreaActive = false;
/* Difficulty select */ /* ------------------------------------------------- */ /* link the selected difficulty with the appropriate amount of memory tiles*/ $4a1d03bd5b66f9fc$var$easyDifficulty.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$numberOfTiles = 4;
    $4a1d03bd5b66f9fc$var$prepareGame();
    $4a1d03bd5b66f9fc$var$toGameArea();
});
$4a1d03bd5b66f9fc$var$mediumDifficulty.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$numberOfTiles = 9;
    $4a1d03bd5b66f9fc$var$prepareGame();
    $4a1d03bd5b66f9fc$var$toGameArea();
});
$4a1d03bd5b66f9fc$var$hardDifficulty.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$numberOfTiles = 15;
    $4a1d03bd5b66f9fc$var$prepareGame();
    $4a1d03bd5b66f9fc$var$toGameArea();
});
$4a1d03bd5b66f9fc$var$customDifficulty.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$toCustomDifficulty();
});
/* function that prepares the game by creating memory tiles in the html document, applies selectors to them,  creates the eventlistener event for when the players clicks the buttons and then moves to the game area */ function $4a1d03bd5b66f9fc$var$prepareGame() {
    $4a1d03bd5b66f9fc$var$createMemoryTilesHtml();
    $4a1d03bd5b66f9fc$var$createMemoryTilesSelector();
    $4a1d03bd5b66f9fc$var$createPlayerInputArray();
    $4a1d03bd5b66f9fc$var$styleColumnsGameArea();
    $4a1d03bd5b66f9fc$var$playerTurn = false;
    $4a1d03bd5b66f9fc$var$computerTurn = true;
    $4a1d03bd5b66f9fc$var$gameAreaActive = true;
}
/* function that navigates to the game area */ function $4a1d03bd5b66f9fc$var$toGameArea() {
    $4a1d03bd5b66f9fc$var$gameArea.classList.toggle("active-window");
    $4a1d03bd5b66f9fc$var$difficultySelectMenu.classList.toggle("active-window");
}
/* function that navigates between the  difficulty selection menu and custom difficulty  */ function $4a1d03bd5b66f9fc$var$toCustomDifficulty() {
    $4a1d03bd5b66f9fc$var$difficultySelectMenu.classList.toggle("active-window");
    $4a1d03bd5b66f9fc$var$customDifficultyMenu.classList.toggle("active-window");
}
/* return from custom difficulty to custom difficulty menu*/ $4a1d03bd5b66f9fc$var$previousBtn.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$messageBoxCustom.innerHTML = "";
    $4a1d03bd5b66f9fc$var$toCustomDifficulty();
});
/* submit the amount of custom tiles the player wants to play with */ $4a1d03bd5b66f9fc$var$nextCustomDifficulty.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$getCustomDifficultyInput();
});
/* validates the input and saves the player input to the numberOfTiles variable */ function $4a1d03bd5b66f9fc$var$getCustomDifficultyInput() {
    if ($4a1d03bd5b66f9fc$var$amountCustomDifficulty.value < 2) $4a1d03bd5b66f9fc$var$messageBoxCustom.innerHTML = "Please select more tiles";
    if (100 < $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value && 581 < $4a1d03bd5b66f9fc$var$screenWidth) $4a1d03bd5b66f9fc$var$messageBoxCustom.innerHTML = "Please select less tiles";
    if (2 <= $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value && $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value <= 100 && 581 < $4a1d03bd5b66f9fc$var$screenWidth) {
        $4a1d03bd5b66f9fc$var$numberOfTiles = $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value;
        $4a1d03bd5b66f9fc$var$messageBoxCustom.innerHTML = "";
        $4a1d03bd5b66f9fc$var$prepareGame();
        /* moves to the game area */ $4a1d03bd5b66f9fc$var$customDifficultyMenu.classList.toggle("active-window");
        $4a1d03bd5b66f9fc$var$gameArea.classList.toggle("active-window");
    }
    /* allow up 50 tiles tiles for a viewport width less than 581px */ if (50 < $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value && 581 >= $4a1d03bd5b66f9fc$var$screenWidth) $4a1d03bd5b66f9fc$var$messageBoxCustom.innerHTML = "Please select less tiles";
    if (2 <= $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value && $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value <= 50 && 581 >= $4a1d03bd5b66f9fc$var$screenWidth) {
        $4a1d03bd5b66f9fc$var$numberOfTiles = $4a1d03bd5b66f9fc$var$amountCustomDifficulty.value;
        $4a1d03bd5b66f9fc$var$messageBoxCustom.innerHTML = "";
        $4a1d03bd5b66f9fc$var$prepareGame();
        /* moves to the game area */ $4a1d03bd5b66f9fc$var$customDifficultyMenu.classList.toggle("active-window");
        $4a1d03bd5b66f9fc$var$gameArea.classList.toggle("active-window");
    }
}
/* game area */ /* ------------------------------------------------- */ /* create a div in the html document with the memory tile properties. This is done an equal amount of times based on the requested amount of memory tiles by the player or selected difficulty setting  */ function $4a1d03bd5b66f9fc$var$createMemoryTilesHtml() {
    for(let i = 1; i <= $4a1d03bd5b66f9fc$var$numberOfTiles; ++i){
        const createMemoryTile = document.createElement("div");
        $4a1d03bd5b66f9fc$var$memoryBlockArea.appendChild(createMemoryTile);
        if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 21) createMemoryTile.classList.add("memory-block", "memory-block-height--10", `memory-block--${i}`);
        if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 70 && 21 < $4a1d03bd5b66f9fc$var$numberOfTiles) createMemoryTile.classList.add("memory-block", "memory-block-height--5", `memory-block--${i}`);
        if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 100 && 70 < $4a1d03bd5b66f9fc$var$numberOfTiles) createMemoryTile.classList.add("memory-block", "memory-block-height--3", `memory-block--${i}`);
    }
}
/* debounce function to delay the next button press */ function $4a1d03bd5b66f9fc$var$debounce(func, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}
function $4a1d03bd5b66f9fc$var$saveInput() {
    console.log("Saving data");
}
const $4a1d03bd5b66f9fc$var$processChange = $4a1d03bd5b66f9fc$var$debounce(()=>$4a1d03bd5b66f9fc$var$saveInput());
/* loop that creates memory tiles based on the selected amount by the player */ function $4a1d03bd5b66f9fc$var$createMemoryTilesSelector() {
    for(let i = 1; i <= $4a1d03bd5b66f9fc$var$numberOfTiles; ++i)$4a1d03bd5b66f9fc$var$memoryTiles[i] = document.querySelector(`.memory-block--${i}`);
}
/* function that toggles the active memory tile */ function $4a1d03bd5b66f9fc$var$toggleMemoryTile(t) {
    $4a1d03bd5b66f9fc$var$memoryTiles[t].classList.toggle("active");
}
/* press the start button to start the game*/ $4a1d03bd5b66f9fc$var$startGame.addEventListener("click", function(number) {
    $4a1d03bd5b66f9fc$var$startGameSequence();
});
function $4a1d03bd5b66f9fc$var$startGameSequence() {
    if ($4a1d03bd5b66f9fc$var$playerTurn === false && $4a1d03bd5b66f9fc$var$computerTurn === true) {
        /* generate a random rumber which will be used to select a random memory tile*/ const generatedNumber = Math.floor(Math.random() * $4a1d03bd5b66f9fc$var$numberOfTiles) + 1;
        $4a1d03bd5b66f9fc$var$generatedNumbersSequence.push(generatedNumber);
        /* disable the start buttons while the sequence is running*/ $4a1d03bd5b66f9fc$var$computerTurn = false;
        /* loop that starts the play sequence */ for(let i = 0; i <= $4a1d03bd5b66f9fc$var$generatedNumbersSequence.length; i++){
            /* function that starts the play sequence with a timer*/ setTimeout(function() {
                $4a1d03bd5b66f9fc$var$messageBox.innerHTML = "";
                for(let t = 1; t <= $4a1d03bd5b66f9fc$var$numberOfTiles; ++t)if ($4a1d03bd5b66f9fc$var$generatedNumbersSequence[i] === t) {
                    $4a1d03bd5b66f9fc$var$toggleMemoryTile(t);
                    $4a1d03bd5b66f9fc$var$memoryTileBeep.play();
                    setTimeout(function() {
                        $4a1d03bd5b66f9fc$var$toggleMemoryTile(t);
                    }, 700);
                }
            /* code that sets the time in ms before the next button is shown */ }, 1000 * i);
            /* activate the buttons for the player after the computer has shown the order sequence*/ if (i === $4a1d03bd5b66f9fc$var$generatedNumbersSequence.length) setTimeout(function() {
                $4a1d03bd5b66f9fc$var$playerTurn = true;
                /* message the player it's their turn */ $4a1d03bd5b66f9fc$var$messageBox.innerHTML = `Repeat the sequence (${$4a1d03bd5b66f9fc$var$generatedNumbersSequence.length - $4a1d03bd5b66f9fc$var$playerNumbersSequence.length} remaining)`;
            }, 1000 * i);
        }
    }
}
/* function that creates multiple events (depending on the selected amount of tiles) for when the player clicks the memory tile buttons to repeat the asked sequence*/ function $4a1d03bd5b66f9fc$var$createPlayerInputArray() {
    for(let t = 1; t <= $4a1d03bd5b66f9fc$var$numberOfTiles; ++t)$4a1d03bd5b66f9fc$var$memoryTiles[t].addEventListener("click", function() {
        if ($4a1d03bd5b66f9fc$var$playerTurn === true) {
            $4a1d03bd5b66f9fc$var$playerNumbersSequence.push(t);
            /* show the remaining amount of buttons that player has yet to press to complete the sequence*/ $4a1d03bd5b66f9fc$var$messageBox.innerHTML = `Repeat the sequence (${$4a1d03bd5b66f9fc$var$generatedNumbersSequence.length - $4a1d03bd5b66f9fc$var$playerNumbersSequence.length} remaining)`;
            $4a1d03bd5b66f9fc$var$winCheck();
            /* Highlights the memorytile after the player has pressed it*/ $4a1d03bd5b66f9fc$var$toggleMemoryTile(t);
            $4a1d03bd5b66f9fc$var$memoryTileBeep.play();
            setTimeout(function() {
                $4a1d03bd5b66f9fc$var$toggleMemoryTile(t);
            }, 300);
        }
    });
}
/* function to check if the player has succesfully input the correct sequence*/ function $4a1d03bd5b66f9fc$var$winCheck() {
    /* check if enough buttons have been pressed by the player to match the amount the computer has input */ if ($4a1d03bd5b66f9fc$var$playerNumbersSequence.length === $4a1d03bd5b66f9fc$var$generatedNumbersSequence.length) {
        /* prepare for next round */ $4a1d03bd5b66f9fc$var$playerTurn = false;
        $4a1d03bd5b66f9fc$var$computerTurn = true;
        /* compare arrays */ if (JSON.stringify($4a1d03bd5b66f9fc$var$playerNumbersSequence) === JSON.stringify($4a1d03bd5b66f9fc$var$generatedNumbersSequence)) {
            /* message player they are correct */ $4a1d03bd5b66f9fc$var$messageBox.innerHTML = "You are correct!";
            /* update score */ $4a1d03bd5b66f9fc$var$currentScore++;
            $4a1d03bd5b66f9fc$var$updateCurrentScore();
            /* check high score & update it if appropriate*/ if ($4a1d03bd5b66f9fc$var$currentScore > $4a1d03bd5b66f9fc$var$highScore) {
                $4a1d03bd5b66f9fc$var$highScore = $4a1d03bd5b66f9fc$var$currentScore;
                $4a1d03bd5b66f9fc$var$updateHighScore();
                $4a1d03bd5b66f9fc$var$newHighScore = true;
                /* message the player they got a new high score */ $4a1d03bd5b66f9fc$var$highScoreMessage.innerHTML = "New high score!";
            }
            /* reset playerInput */ $4a1d03bd5b66f9fc$var$playerNumbersSequence = [];
        } else $4a1d03bd5b66f9fc$var$lostTheGame();
    }
    if ($4a1d03bd5b66f9fc$var$playerNumbersSequence.length !== $4a1d03bd5b66f9fc$var$generatedNumbersSequence.length) {
        for(let i = 0; i < $4a1d03bd5b66f9fc$var$playerNumbersSequence.length; i++)if ($4a1d03bd5b66f9fc$var$generatedNumbersSequence[i] !== $4a1d03bd5b66f9fc$var$playerNumbersSequence[i]) $4a1d03bd5b66f9fc$var$lostTheGame();
    }
}
/* losing the game function*/ function $4a1d03bd5b66f9fc$var$lostTheGame() {
    /* message player they are incorrect */ $4a1d03bd5b66f9fc$var$messageBox.innerHTML = "You are incorrect... try again";
    /* reset high score text */ $4a1d03bd5b66f9fc$var$highScoreMessage.innerHTML = "";
    if ($4a1d03bd5b66f9fc$var$newHighScore === true && 1 < $4a1d03bd5b66f9fc$var$highScore) {
        /* show high score popup modal */ $4a1d03bd5b66f9fc$var$ShowHideHighScoreModal();
        $4a1d03bd5b66f9fc$var$highScoreNumberModal.innerHTML = $4a1d03bd5b66f9fc$var$highScore;
        /* select random gif via a number of 1 to 4*/ const randomGif = Math.floor(Math.random() * 4) + 1;
        /* select the correct gif based on the randomly selected number*/ if (randomGif === 1) $4a1d03bd5b66f9fc$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($92613537cea89aa2$exports)));
        if (randomGif === 2) $4a1d03bd5b66f9fc$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($b49ded1f4ce6225d$exports)));
        if (randomGif === 3) $4a1d03bd5b66f9fc$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($beb728e107eda2af$exports)));
        if (randomGif === 4) $4a1d03bd5b66f9fc$var$highScoreModalGif.src = (0, (/*@__PURE__*/$parcel$interopDefault($44da6374d029a4b3$exports)));
        /* play applause sound effect */ $4a1d03bd5b66f9fc$var$applauseSound.play();
        $4a1d03bd5b66f9fc$var$applauseSound.loop = true;
        $4a1d03bd5b66f9fc$var$newHighScore = false;
    }
    /* update score */ $4a1d03bd5b66f9fc$var$currentScore = 0;
    $4a1d03bd5b66f9fc$var$updateCurrentScore();
    /* prepare for next round */ $4a1d03bd5b66f9fc$var$playerTurn = false;
    $4a1d03bd5b66f9fc$var$computerTurn = true;
    /* reset game*/ $4a1d03bd5b66f9fc$var$playerNumbersSequence = [];
    $4a1d03bd5b66f9fc$var$generatedNumbersSequence = [];
}
/* functions that updates the scores in the html document*/ /*  update the current score  */ function $4a1d03bd5b66f9fc$var$updateCurrentScore() {
    $4a1d03bd5b66f9fc$var$currentScoreEL.innerHTML = $4a1d03bd5b66f9fc$var$currentScore;
}
/*  update the high score  */ function $4a1d03bd5b66f9fc$var$updateHighScore() {
    $4a1d03bd5b66f9fc$var$highScoreEL.innerHTML = $4a1d03bd5b66f9fc$var$highScore;
}
/* high score modal */ /* hide the modal once the player clicked it*/ $4a1d03bd5b66f9fc$var$highScoreModal.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$ShowHideHighScoreModal();
});
function $4a1d03bd5b66f9fc$var$ShowHideHighScoreModal() {
    $4a1d03bd5b66f9fc$var$highScoreModal.classList.toggle("active-window");
    $4a1d03bd5b66f9fc$var$applauseSound.pause();
    $4a1d03bd5b66f9fc$var$applauseSound.currentTime = 0;
}
/* style the columns so all the memory tiles fit on the screen */ function $4a1d03bd5b66f9fc$var$styleColumnsGameArea() {
    /* styling for 6 tiles or less */ if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 6) {
        $4a1d03bd5b66f9fc$var$memoryBlockArea.className = "memory-block-area margin--30 gap--3 grid-col";
        $4a1d03bd5b66f9fc$var$gridCol[0].style.gridTemplateColumns = `repeat(2, 1fr)`;
    }
    /* styling for tiles between the numbers 6 and 21 */ for(let i = 2; i < 7; i++)if ($4a1d03bd5b66f9fc$var$numberOfTiles <= i * 3 + 3 && i * 3 < $4a1d03bd5b66f9fc$var$numberOfTiles) {
        $4a1d03bd5b66f9fc$var$memoryBlockArea.className = `memory-block-area margin--${40 - i * 5} gap--3 grid-col`;
        $4a1d03bd5b66f9fc$var$gridCol[0].style.gridTemplateColumns = `repeat(${i + 1}, 1fr)`;
    }
    /* styling for tiles between the numbers 22 and 25 */ if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 25 && 21 < $4a1d03bd5b66f9fc$var$numberOfTiles) {
        $4a1d03bd5b66f9fc$var$memoryBlockArea.className = "memory-block-area margin--30 gap--2 grid-col";
        $4a1d03bd5b66f9fc$var$gridCol[0].style.gridTemplateColumns = `repeat(5, 1fr)`;
    }
    /* styling for tiles between the numbers 26 and 70*/ for(let i = 1; i < 10; i++)if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 25 + i * 5 && 20 + i * 5 < $4a1d03bd5b66f9fc$var$numberOfTiles) {
        $4a1d03bd5b66f9fc$var$memoryBlockArea.className = `memory-block-area gap--2 grid-col`;
        $4a1d03bd5b66f9fc$var$gridCol[0].style.gridTemplateColumns = `repeat(${i + 5}, 1fr)`;
        /* select margin that's appriopriate for the number of tiles*/ if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 35 && 25 < $4a1d03bd5b66f9fc$var$numberOfTiles) $4a1d03bd5b66f9fc$var$memoryBlockArea.classList.add("margin--30");
        if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 50 && 35 < $4a1d03bd5b66f9fc$var$numberOfTiles) $4a1d03bd5b66f9fc$var$memoryBlockArea.classList.add("margin--20");
        if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 60 && 50 < $4a1d03bd5b66f9fc$var$numberOfTiles) $4a1d03bd5b66f9fc$var$memoryBlockArea.classList.add("margin--15");
        if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 70 && 60 < $4a1d03bd5b66f9fc$var$numberOfTiles) $4a1d03bd5b66f9fc$var$memoryBlockArea.classList.add("margin--10");
    }
    /* styling for tiles between the numbers 70 and 100*/ for(let i = 1; i < 4; i++)if ($4a1d03bd5b66f9fc$var$numberOfTiles <= 70 + i * 10 && 60 + i * 10 < $4a1d03bd5b66f9fc$var$numberOfTiles) {
        $4a1d03bd5b66f9fc$var$memoryBlockArea.className = `memory-block-area margin--${40 - i * 10} gap--1 grid-col`;
        $4a1d03bd5b66f9fc$var$gridCol[0].style.gridTemplateColumns = `repeat(${5 + i * 5}, 1fr)`;
    }
}
/* quit the game */ /* ------------------------------------------------- */ /* quit te game, reset all setting to default and return to the difficult select screen */ $4a1d03bd5b66f9fc$var$quitBtn.addEventListener("click", function() {
    $4a1d03bd5b66f9fc$var$removeMemoryTilesHtml();
    $4a1d03bd5b66f9fc$var$currentScore = 0;
    $4a1d03bd5b66f9fc$var$updateCurrentScore();
    $4a1d03bd5b66f9fc$var$highScore = 0;
    $4a1d03bd5b66f9fc$var$updateHighScore();
    $4a1d03bd5b66f9fc$var$generatedNumbersSequence = [];
    $4a1d03bd5b66f9fc$var$playerNumbersSequence = [];
    $4a1d03bd5b66f9fc$var$highScoreMessage.innerHTML = "";
    $4a1d03bd5b66f9fc$var$messageBox.innerHTML = "Press start to begin the game";
    $4a1d03bd5b66f9fc$var$gameAreaActive = false;
    $4a1d03bd5b66f9fc$var$toGameArea();
});
/* remove the generated memory tiles in the html document to reset the game */ function $4a1d03bd5b66f9fc$var$removeMemoryTilesHtml() {
    for(let i = 1; i <= $4a1d03bd5b66f9fc$var$numberOfTiles; ++i)$4a1d03bd5b66f9fc$var$memoryBlockArea.removeChild($4a1d03bd5b66f9fc$var$memoryBlockArea.lastElementChild);
}

})();
//# sourceMappingURL=index.d12e3816.js.map
